import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        maxWidth: "800px",
        minWidth: "800px"
    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 15px 0px'
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        alignItems: 'baseline',
        padding: '15px 10px',
        backgroundColor: "#454545",
        justifyContent: 'space-between',
        cursor: 'move',
    },
    note: {
        minHeight: '240px !important',
        padding: '7px 10px',
        maxWidth: '800px',
    
        "& .RichTextEditor__editor___1QqIU": {
            maxHeight: '240px !important',
            overflow: 'auto',
        }
    },
}));